
import { bestPicFormat } from '@/assets/scripts/utils'

export default {
  name: 'ApiEnumForces',
  props: {
    apiData: { type: Object, default: () => {} },
  },
  created() {
    this.bestPicFormat = bestPicFormat
  },
}
